export const shouldSkipFilterLink = (isPlpFiltersSeoEnabled: boolean, isOnlyOption: boolean) =>
  !isPlpFiltersSeoEnabled || isOnlyOption;
